export const CONVERSATION_TYPES = {
    PERSONAL: 'personal',
    SDKGROUP: 'sdkGroup',
};
